module.exports = __webpack_public_path__ + "img/darkLogo.fbd684ad.svg";